<template>
  <div class="filter-section" v-if="globals.initialized" :class="{'-mobile-filter-open': props.mobileFilterOpen}">
    <div class="filter-bg" @click="handleCloseFilter()"></div>
    <form id="product-filter" class="module-filter-wrapper form">
      <div class="filter__headline">
        <span class="heading epsilon -color-alpha">{{ $t('list.filter.headline') }}</span>
        <div class="filter__close" @click="handleCloseFilter()"></div>
      </div>
      <div class="filter-wrap" v-if="props.filterType === 'List'">
        <div class="filter__search">
          <SearchInput></SearchInput>
        </div>
      </div>
      <FilterDropdown
        v-for="(filter, key, index) in filters.filters" :key="index"
        :title="filter.label"
        :type="key"
        :filterType="filter.options[0].type"
        :values="filter.options"
        @update:modelValue="newValue => {filters.selectedFilters[key] = newValue; triggerFilter()}"
        :modelValue="filters.selectedFilters[key]"
        :filterListType="filterType"
      ></FilterDropdown>
    </form>
  </div>
</template>

<script setup>

import SearchInput from '@/components/SearchInput'
import FilterDropdown from '@/components/FilterDropdown'
import { useFilterStore } from '@/stores/filter'
import { useGlobalStore } from '@/stores'
import { defineProps, computed, defineEmits } from 'vue'
import { useMatingPairsFilterStore } from "@/stores/matingPairsFilter";
import { useMatingPairsStore } from "@/stores/matingPairs";
import { usePartsStore } from '@/stores/parts'

const globals = useGlobalStore()
const matingPairs = useMatingPairsStore()
const parts = usePartsStore()

const props = defineProps(['mobileFilterOpen', 'filterType'])

const filters = computed(() =>
{
  if (props.filterType === 'List')
  {
    return useFilterStore()
  } else {
    return useMatingPairsFilterStore()
  }
})

function triggerFilter () {
  if (props.filterType === 'List')
  {
    globals.filter()
    parts.currentPage = 1
  } else
  {
    matingPairs.filterMatingPairs()
    matingPairs.currentPage = 1
  }
}

const emit = defineEmits(['closeFilter'])

function handleCloseFilter () {
  emit('closeFilter')
}

</script>

